// src/constants.js

export const CONTRACT_ADDRESS = "0xd7b574860dd5d767129234f9b3404a0ab3c98164"; // Ersetzen Sie dies mit Ihrer Contract-Adresse

export const ABI = [
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_batchNumber",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_beanOrigin",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_beanType",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_beanSupplier",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_beanHarvestYear",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_beanMoistureDensity",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_roastDate",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_roastDuration",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_temperatureProfile",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_roastColor",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_roastingMachine",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_roasterName",
				"type": "string"
			}
		],
		"name": "addRoastBatch",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "string",
				"name": "batchNumber",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "beanOrigin",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "beanType",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "beanSupplier",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "beanHarvestYear",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "beanMoistureDensity",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "roastDate",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "roastDuration",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "temperatureProfile",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "roastColor",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "roastingMachine",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "roasterName",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "blockNumber",
				"type": "uint256"
			}
		],
		"name": "RoastBatchAdded",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getAllBatchNumbers",
		"outputs": [
			{
				"internalType": "string[]",
				"name": "",
				"type": "string[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_batchNumber",
				"type": "string"
			}
		],
		"name": "getRoastBatch",
		"outputs": [
			{
				"components": [
					{
						"internalType": "string",
						"name": "batchNumber",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "beanOrigin",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "beanType",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "beanSupplier",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "beanHarvestYear",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "beanMoistureDensity",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "roastDate",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "roastDuration",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "temperatureProfile",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "roastColor",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "roastingMachine",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "roasterName",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "blockNumber",
						"type": "uint256"
					}
				],
				"internalType": "struct JABCoffeeRoastData.RoastBatch",
				"name": "batch",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
]